import React from 'react';
import { Box } from '@mui/material';
import DrawerHeader from './DrawerHeader';
import DrawerNavigation from './DrawerNavigation';
import DrawerActions from './DrawerActions';

const DashboardDrawer = ({
  userProfile,
  currentTab,
  setCurrentTab,
  isMobile,
  setMobileOpen,
  setProfileInfoOpen,
  viewPublicProfile,
  copyPublicLink,
  onQRCodeClick
}) => {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <DrawerHeader
        userProfile={userProfile}
        setCurrentTab={setCurrentTab}
        setProfileInfoOpen={setProfileInfoOpen}
        onQRCodeClick={onQRCodeClick}
      />
      
      <DrawerNavigation 
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        isMobile={isMobile}
        setMobileOpen={setMobileOpen}
        userProfile={userProfile}
      />
      
      <DrawerActions
        viewPublicProfile={viewPublicProfile}
        copyPublicLink={copyPublicLink}
        onQRCodeClick={onQRCodeClick}
      />
    </Box>
  );
};

export default DashboardDrawer;
